export const shopifyGRecaptcha = async (form, action) => {
    try {
        await window.grecaptcha.execute(window.Shopify.recaptchaV3.siteKey, {
            action
        }).then(function (value) {
            let n = form.querySelector('input[name=recaptcha-v3-token]');
            if (n instanceof HTMLElement) {
                n.setAttribute('value', value);
            }
            else {
                n = document.createElement('input');
                n.setAttribute('name', 'recaptcha-v3-token');
                n.setAttribute('type', 'hidden');
                n.setAttribute('value', value);
                form.appendChild(n);
            }
        });
    }
    catch (e) {
        console.log('recaptcha error: ', e);
    }
};
